import React, { ReactElement } from 'react';
import { appLoaderLogicInitializer } from '../logic/logic-initializer';
import { UILogicProvider } from '../ui/shared/providers/UILogicProvider';
import ApplicationThemeProvider from '../ui/features/application-theme/ApplicationThemeProvider';
import '../infrastructure/localization/i18n';
import UiKit from '../../shared/ui/ui-kit';
import { AppLoaderGlobalStyle } from '../ui/shared/styles/AppLoaderGlobalStyle';
import { Router } from '../ui/features/navigation/Router';
import { NotificationsBuffer } from '../ui/features/notification/NotificationsBuffer';

interface AppLoaderAppProps {}
function AppLoaderApp({}: AppLoaderAppProps): ReactElement {
  appLoaderLogicInitializer.initLogic();

  return (
    <>
      <AppLoaderGlobalStyle />
      <UILogicProvider uiModules={appLoaderLogicInitializer.logic.ui}>
        <ApplicationThemeProvider>
          <UiKit.AppProvider>
            <Router />
            <NotificationsBuffer />
          </UiKit.AppProvider>
        </ApplicationThemeProvider>
      </UILogicProvider>
    </>
  );
}

export { AppLoaderApp };
